export const ToggleEndpoints = {
  getFeatureToggle: (toggleName: string) => `/rest/public/v1/toggles/${toggleName}/status`
}
